module.exports = __webpack_public_path__ + "static/media/delete.8a35f943.png";